import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CommercialRental } from '../../models/response-commercial-rental';

@Component({
  selector: 'app-response-commercial-rental',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './response-commercial-rental.component.html'
})
export class ResponseCommercialRentalComponent {

    @Input() response:CommercialRental;

}
